//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      isExpand: false,
      currentStep: '01',
      currentStep1: '01',
      message: '发起双录',
      message1: '阅读风险揭示书',
      steps: ['阅读风险揭示书', '签字', '签章'],
      message2: '合同文件签署',
      showindicators: false,
      loopenable: false
    }
  },
  created () {
    this.$vux.loading.hide()
  },
  methods: {
    onChange: function (index) {
      this.currentStep = '0' + (Number(index) + 1)
      this.message1 = this.steps[Number(index)]
    },
    leftClick: function (event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep - 2))
    },
    rightClick: function (event) {
      this.$refs['vanswipe'].swipeTo(Number(this.currentStep))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Guide/contractGuide.vue